module.exports = __webpack_public_path__ + "media/images/lb/358-143bd339d59d728e4c49f910b77778a0.svg";